module.exports = __webpack_public_path__ + "static/img/English(US).22f4e636.png";